import React, { Fragment, useContext } from "react";
import ChatAppContext from "../../../Chat";
import avatar from "../../../assets/images/avatar.png";

const ChatMenu = () => {
  const { selectedUser, selectedUserProfile } = useContext(ChatAppContext) || {};

  const renderProfileInfo = (label, value, isLink = false) => {
    if (!value) return null;
    return (
      <div className="mb-2">
        <span className="font-weight-bold" style={{ fontWeight: "bold" }}>
          {label}:
        </span>{" "}
        {isLink ? (
          <a href={value} target="_blank" rel="noopener noreferrer">
            {value}
          </a>
        ) : (
          value
        )}
      </div>
    );
  };

  const title =
    selectedUser?.admin_chat_title ||
    [selectedUser?.jobseeker_full_name, selectedUser?.recruiter_full_name]
      .filter(Boolean)
      .join(" ↔ ");

  return (
    <Fragment>
      <div
        className="user-profile custom-scrollbar"
        style={{ overflowY: "auto", height: "560px" }}
      >
        <div className="image text-center mb-3">
          <img
            className="rounded-circle"
            src={selectedUser?.jobseeker_photo || avatar}
            alt=""
            style={{ width: "100px", height: "100px" }}
          />
        </div>
        <div className="user-content text-center">
          <h5 className="text-center text-uppercase mb-2">{title}</h5>
          {selectedUserProfile?.support_chat ? (
            <p className="mb-2 small text-muted">
              Private support chat — details below are for this user only.
            </p>
          ) : null}
          {!selectedUserProfile?.support_chat && selectedUserProfile?.recruiter_full_name && (
            <p className="mb-1 small text-muted">
              Recruiter: {selectedUserProfile.recruiter_full_name}
            </p>
          )}
          {!selectedUserProfile?.support_chat && selectedUserProfile?.recruiter_email && (
            <p className="mb-2 small">{selectedUserProfile.recruiter_email}</p>
          )}
          <hr />
          <div
            className="text-left profile-details"
            style={{ margin: "20px", textAlign: "left" }}
          >
            {selectedUserProfile && (
              <Fragment>
                {renderProfileInfo(
                  "Company Name",
                  selectedUserProfile.company_name
                )}
                {renderProfileInfo(
                  "Company Email",
                  selectedUserProfile.company_email
                )}
                {renderProfileInfo(
                  "Company Phone",
                  selectedUserProfile.company_phone
                )}
                {renderProfileInfo("Address", selectedUserProfile.address)}
                {renderProfileInfo("Zip Code", selectedUserProfile.zip_code)}
                {renderProfileInfo(
                  "Company Website",
                  selectedUserProfile.company_website,
                  true
                )}
                {renderProfileInfo(
                  "Jobseeker Email 1",
                  selectedUserProfile.jobseeker_email1
                )}
                {renderProfileInfo(
                  "Jobseeker Email 2",
                  selectedUserProfile.jobseeker_email2
                )}
                {renderProfileInfo(
                  "Jobseeker Phone 1",
                  selectedUserProfile.jobseeker_phone1
                )}
                {renderProfileInfo(
                  "Jobseeker Phone 2",
                  selectedUserProfile.jobseeker_phone2
                )}
                {renderProfileInfo(
                  "Preferred Department",
                  selectedUserProfile.jobseeker_preferred_department
                )}
                {renderProfileInfo(
                  "Preferred Employment Type",
                  selectedUserProfile.jobseeker_preferred_employment_type
                )}
                {renderProfileInfo(
                  "Preferred Industry",
                  selectedUserProfile.jobseeker_preferred_industry
                )}
                {renderProfileInfo(
                  "Preferred Job Type",
                  selectedUserProfile.jobseeker_preferred_job_type
                )}
                {renderProfileInfo(
                  "Preferred Location",
                  selectedUserProfile.jobseeker_preferred_location
                )}
                {renderProfileInfo(
                  "Preferred Salary",
                  selectedUserProfile.jobseeker_preferred_salary
                )}
                {renderProfileInfo(
                  "Preferred Shift",
                  selectedUserProfile.jobseeker_preferred_shift
                )}
                {selectedUserProfile.social_links &&
                  selectedUserProfile.social_links.map((link) =>
                    renderProfileInfo(link.social_profile_name, link.url, true)
                  )}
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ChatMenu;
